import { Context } from '@nuxt/types';
import { getTokenQuery } from '~/utils';

export default function ({ $auth, redirect, from, store }: Context) {
  if (
    $auth.loggedIn &&
    !$auth.hasOnboarded({
      supportsRelocationFeature: store.state.tenant.tenant.supports_relocation_feature,
    })
  ) {
    redirect({
      name: $auth.getOnboardingRoute(),
      // @ts-ignore
      query: getTokenQuery(from),
    });
  }
}
